import axios from '../axiosConfig';

export interface RelatedPCLItem {
  id: string;
  name?: string;
  description?: string;
}

export async function fetchRelatedPCLsByCodeIndexId(codeIndexId: string): Promise<RelatedPCLItem[]> {
  try {
    // New endpoint shape: GET /RelatedPcls/{codeIndexId}
    const url = `/RelatedPcls/${encodeURIComponent(codeIndexId)}`;
    const { data } = await axios.get(url);

    if (Array.isArray(data)) {
      // API can return an array of strings: ["0589","0583",...]
      const ids: string[] = data.map((item: any) =>
        typeof item === 'string' || typeof item === 'number'
          ? String(item)
          : String(item?.id ?? item?.pcl ?? item?.code ?? '')
      ).filter(Boolean);

      const uniqueIds = Array.from(new Set(ids));
      return uniqueIds.map((id) => ({ id, name: id }));
    }

    // Fallback to empty list if server returns unexpected structure
    return [];
  } catch (error) {

    return [];
  }
}


